module.exports = __webpack_public_path__ + "img/search.7c1f6d5a.svg";